// Escala oficial de breakpoints do app (px). Única fonte de truth — TS e CSS
// consomem os MESMOS literais (o CSS não tem custom-media, então repete 480/768/1024
// de forma consistente; ver comentário no topo de tokens.css).
//   sm  480  — telefones estreitos / colapso de linhas densas
//   md  768  — limite mobile ↔ tablet (Sidebar → BottomNav)
//   lg 1024  — limite tablet ↔ desktop (painéis laterais viram sheet)
export const BREAKPOINTS = { sm: 480, md: 768, lg: 1024 } as const;

// Media query strings prontas pro matchMedia (useMediaQuery). Casam com as
// media queries dos .module.css (max-width) — mantenha em sincronia.
export const MEDIA = {
  mobile: `(max-width: ${BREAKPOINTS.md}px)`,
  tablet: `(max-width: ${BREAKPOINTS.lg}px)`,
} as const;
